export const NotFound = () => {
  return <div>NOT FOUND</div>
}
